import _core from "./core";
import * as _fizzyUiUtils2 from "fizzy-ui-utils";

var _fizzyUiUtils = "default" in _fizzyUiUtils2 ? _fizzyUiUtils2.default : _fizzyUiUtils2;

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// add, remove cell
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory(_core, _fizzyUiUtils);
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != "undefined" ? window : exports, function factory(Flickity, utils) {
  // append cells to a document fragment
  function getCellsFragment(cells) {
    let fragment = document.createDocumentFragment();
    cells.forEach(cell => fragment.appendChild(cell.element));
    return fragment;
  } // -------------------------- add/remove cell prototype -------------------------- //


  let proto = Flickity.prototype;
  /**
   * Insert, prepend, or append cells
   * @param {[Element, Array, NodeList]} elems - Elements to insert
   * @param {Integer} index - Zero-based number to insert
   */

  proto.insert = function (elems, index) {
    let cells = this._makeCells(elems);

    if (!cells || !cells.length) return;
    let len = (this || _global).cells.length; // default to append

    index = index === undefined ? len : index; // add cells with document fragment

    let fragment = getCellsFragment(cells); // append to slider

    let isAppend = index === len;

    if (isAppend) {
      (this || _global).slider.appendChild(fragment);
    } else {
      let insertCellElement = (this || _global).cells[index].element;

      (this || _global).slider.insertBefore(fragment, insertCellElement);
    } // add to this.cells


    if (index === 0) {
      // prepend, add to start
      (this || _global).cells = cells.concat((this || _global).cells);
    } else if (isAppend) {
      // append, add to end
      (this || _global).cells = (this || _global).cells.concat(cells);
    } else {
      // insert in this.cells
      let endCells = (this || _global).cells.splice(index, len - index);

      (this || _global).cells = (this || _global).cells.concat(cells).concat(endCells);
    }

    this._sizeCells(cells);

    this.cellChange(index);
    this.positionSliderAtSelected();
  };

  proto.append = function (elems) {
    this.insert(elems, (this || _global).cells.length);
  };

  proto.prepend = function (elems) {
    this.insert(elems, 0);
  };
  /**
   * Remove cells
   * @param {[Element, Array, NodeList]} elems - ELements to remove
   */


  proto.remove = function (elems) {
    let cells = this.getCells(elems);
    if (!cells || !cells.length) return;
    let minCellIndex = (this || _global).cells.length - 1; // remove cells from collection & DOM

    cells.forEach(cell => {
      cell.remove();

      let index = (this || _global).cells.indexOf(cell);

      minCellIndex = Math.min(index, minCellIndex);
      utils.removeFrom((this || _global).cells, cell);
    });
    this.cellChange(minCellIndex);
    this.positionSliderAtSelected();
  };
  /**
   * logic to be run after a cell's size changes
   * @param {Element} elem - cell's element
   */


  proto.cellSizeChange = function (elem) {
    let cell = this.getCell(elem);
    if (!cell) return;
    cell.getSize();

    let index = (this || _global).cells.indexOf(cell);

    this.cellChange(index); // do not position slider after lazy load
  };
  /**
   * logic any time a cell is changed: added, removed, or size changed
   * @param {Integer} changedCellIndex - index of the changed cell, optional
   */


  proto.cellChange = function (changedCellIndex) {
    let prevSelectedElem = (this || _global).selectedElement;

    this._positionCells(changedCellIndex);

    this._updateWrapShiftCells();

    this.setGallerySize(); // update selectedIndex, try to maintain position & select previous selected element

    let cell = this.getCell(prevSelectedElem);
    if (cell) (this || _global).selectedIndex = this.getCellSlideIndex(cell);
    (this || _global).selectedIndex = Math.min((this || _global).slides.length - 1, (this || _global).selectedIndex);
    this.emitEvent("cellChange", [changedCellIndex]); // position slider

    this.select((this || _global).selectedIndex);
  }; // -----  ----- //


  return Flickity;
});

export default exports;